import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz-', 21);
import { ValidationService } from '../../services/validation.service';
import { ManagementArea } from '../area-models/management-area.model';
import { SharedMethodsService } from '../../services/shared-methods.service';

export class PauseReport {

  internalId: string = '';

  pauseDate: Date = new Date(); 

  pauseEndDate: Date = new Date();

  reason: string = '';

  licenseNumber: string = '';

  inactivityReason: string = '';

  reportDTLNodeComments: string = '';

  managementArea: ManagementArea = new ManagementArea();

  reportID: string = '';

  confirmationNumber: string = 'Incomplete';

  emailedAt: string = ''; // written by the backend when the report email is actually sent; suppresses duplicate sends

  completionDate: Date = new Date(); // date the report was completed within the app

  submissionDate: Date = new Date(); // date the report was submitted to DFO (only accurate if 'isSubmitted'=true)

  comments: string = ''; // optional

  /* Flags for programmatical use */

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  isComplete: boolean = false; // flag that tells us if the report has been completed


  lastUpdate: Date = new Date();

  constructor() {

    this.internalId = 'id-' + nanoid();
    this.reportID = SharedMethodsService.generateReportID("P");

  }

  public toString(): string {
    return 'Pause Date: ' + this.pauseDate + '; Confirmation Number: ' + this.confirmationNumber;
  }

  // check if the user's Pause Fishing Reports are defined
  public static transformAnonymous(pauseReports: any): PauseReport[] {

    // if it is not defined, set a new one
    if (!pauseReports) {
      return [];
    }

    let userPauseReports: PauseReport[] = [];
    for (let pauseReport of pauseReports) {
      let userPauseReport: PauseReport = new PauseReport();
      userPauseReport.internalId = pauseReport.internalId ?? 'id-' + nanoid();
      userPauseReport.inactivityReason = pauseReport.inactivityReason;
      userPauseReport.licenseNumber = pauseReport.licenseNumber;
      userPauseReport.reportDTLNodeComments = pauseReport.reportDTLNodeComments;
      userPauseReport.pauseDate = ValidationService.validateDate(pauseReport.pauseDate);
      userPauseReport.pauseEndDate = ValidationService.validateDate(pauseReport.pauseEndDate);
      userPauseReport.managementArea = ManagementArea.transformAnonymous(pauseReport.managementArea);
      userPauseReport.confirmationNumber = pauseReport.confirmationNumber ?? '';
      userPauseReport.emailedAt = pauseReport.emailedAt ?? '';
      userPauseReport.completionDate = ValidationService.validateDate(pauseReport.completionDate);
      userPauseReport.submissionDate = ValidationService.validateDate(pauseReport.submissionDate);
      userPauseReport.comments = pauseReport.comments ?? '';
      userPauseReport.reportID = pauseReport.reportID;
      userPauseReport.isSubmitted = pauseReport.isSubmitted ?? false;
      userPauseReport.isComplete = pauseReport.isComplete ?? false;
      userPauseReport.lastUpdate = pauseReport.lastUpdate ?? new Date();
      userPauseReports.push(userPauseReport);
    }
    return userPauseReports;

  }

}
